import { skipToken, useQuery } from '@tanstack/react-query'
import type { ProcessesApiGetLogisticsSummaryRequest } from '@itsrever/rever-api'
import { getProcessLogistics } from '@/api/processes-api'

export const useProcessLogistics = ({
  processId
}: Partial<ProcessesApiGetLogisticsSummaryRequest>) => {
  return useQuery({
    queryKey: ['process-logistics', processId],
    queryFn:
      processId !== undefined
        ? async () => {
            const response = await getProcessLogistics({ processId })

            return response
          }
        : skipToken
  })
}
